import InviteFormField from './InviteFormField';
import InviteTextInput from './InviteTextInput';

interface InviteNameFieldsProps {
  firstName: string;
  lastName: string;
  onFirstNameChange: (value: string) => void;
  onLastNameChange: (value: string) => void;
}

/** First / last name side by side. */
export default function InviteNameFields({
  firstName,
  lastName,
  onFirstNameChange,
  onLastNameChange,
}: InviteNameFieldsProps) {
  return (
    <div className="grid grid-cols-2 gap-3">
      <InviteFormField label="First name" required>
        <InviteTextInput aria-label="First name" value={firstName} onChange={onFirstNameChange} />
      </InviteFormField>
      <InviteFormField label="Last name" required>
        <InviteTextInput aria-label="Last name" value={lastName} onChange={onLastNameChange} />
      </InviteFormField>
    </div>
  );
}
